import { handleActions } from 'redux-actions';
import findIndex from 'lodash/findIndex';
import set from 'lodash/set';

import {
  REQUEST_TRANSPORT_GRANTS,
  REQUEST_TRANSPORT_GRANTS_SUCCESS,
  REQUEST_TRANSPORT_GRANTS_FAILURE,
  EMPLOYEE_TRANSPORT_GRANT_REGISTER,
  EMPLOYEE_TRANSPORT_GRANT_REGISTER_SUCCESS,
  EMPLOYEE_TRANSPORT_GRANT_REGISTER_FAILURE,
} from './constants';

const initialState = {
  grantsLoading: true,
  grantsError: null,
  transportationGrants: [],
  registerError: null,
  registerLoadingById: {},
};

export default handleActions({
  [REQUEST_TRANSPORT_GRANTS]: state => ({
    ...state,
    loadingGrants: true,
    transportationsLoadingById: {},
  }),
  [REQUEST_TRANSPORT_GRANTS_SUCCESS]: (state, { transportationGrants }) => ({
    ...state,
    grantsLoading: false,
    transportationGrants,
  }),
  [REQUEST_TRANSPORT_GRANTS_FAILURE]: (state, { error }) => ({
    ...state,
    grantsLoading: false,
    grantsError: error.message || error.Message,
  }),
  [EMPLOYEE_TRANSPORT_GRANT_REGISTER]: (state, { transportationGrantId }) => ({
    ...state,
    registerLoadingById: {
      ...state.registerLoadingById,
      [transportationGrantId]: true,
    },
  }),
  [EMPLOYEE_TRANSPORT_GRANT_REGISTER_SUCCESS]: (state, { transportationGrantId, employeeMasterTransportations }) => {
    const index = findIndex(state.transportationGrants, ['HrTransportationGrantID', transportationGrantId]);
    if (index > -1) {
      set(state, `transportationGrants[${index}].Previous`, employeeMasterTransportations);
    }
    return ({
      ...state,
      registerLoadingById: {
        ...state.registerLoadingById,
        [transportationGrantId]: false,
      },
    });
  },
  [EMPLOYEE_TRANSPORT_GRANT_REGISTER_FAILURE]: (state, { error, transportationGrantId }) => ({
    ...state,
    registerError: error.message || error.Message,
    registerLoadingById: {
      ...state.registerLoadingById,
      [transportationGrantId]: false,
    },
  }),
}, initialState);



// WEBPACK FOOTER //
// ./src/sites/transportationGrants/reducer.js